module.exports = __webpack_public_path__ + "media/images/players/JONES_MATT-5a32a609c88ea8a4f5153dbeb4b4c42d.png";